import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { getMedewerkerWeek } from '../work-quality.api';
import type { PersoonsweekAntwoord } from '../work-quality.api';

export interface CollegaWeekLezing {
  data?: PersoonsweekAntwoord;
  isLoading: boolean;
  isError: boolean;
  /** De pagina is geweigerd (403): geen storing van de meting, en het scherm zegt dat ook zo. */
  isGeweigerd?: boolean;
  refetch: () => void;
}

/**
 * De week van een collega — het volle antwoord, met namen; de eigen week is daar sinds story 19 een smalle deelvorm van.
 *
 * `userId` mag `null` zijn: een adres met een medewerkersnummer dat er geen is wordt aan de rand
 * geweigerd en er gaat dan geen aanroep uit. Dat is niet alleen zuinig maar ook eerlijk — een
 * onbereikbare meting zou anders de schuld krijgen van een typefout in het adres.
 */
export function useCollegaWeek(userId: number | null, week: string): CollegaWeekLezing {
  const query = useQuery({
    queryKey: ['workQuality', 'colleague', userId, week],
    queryFn: () => getMedewerkerWeek(userId!, week),
    enabled: userId !== null && week !== '',
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    isGeweigerd: isAxiosError(query.error) && query.error.response?.status === 403,
    refetch: () => {
      void query.refetch();
    },
  };
}
